import { Button, Form, Input } from 'antd';
import styles from './index.module.less';
import EmailIcon from '@/assets/imgs/email.svg';
import PasswordIcon from '@/assets/imgs/password.svg';
import passwordShownIcon from '@/assets/imgs/pwd-show.svg';
import passwordHiddenIcon from '@/assets/imgs/pwd-hide.svg';
import { useState } from 'react';
import { userApi } from '@/axios/user';
import { USER_TOKEN } from '@/stores/user';

interface LoginFormValues {
  email: string;
  password: string;
}

interface ApiError {
  err_msg?: string;
}

const Login = () => {
  const [form] = Form.useForm<LoginFormValues>();
  const [loading, setLoading] = useState(false);
  const [errMsg, setErrMsg] = useState<string>();

  const urlQuery = new URLSearchParams(location.search);
  const redirect = urlQuery.get('redirect');

  const onFinish = async (values: LoginFormValues) => {
    setLoading(true);
    try {
      const { password } = values;
      const res = await userApi.login({
        email: values.email.trim(),
        password: password.trim(),
      });
      localStorage.setItem(USER_TOKEN, JSON.stringify({}));
      const defaultPath = res?.roleKey === 'CUSTOMER' ? '/customers' : '/company';
      const redirectUrl = redirect ? decodeURIComponent(redirect) : defaultPath;
      location.href = redirectUrl;
    } catch (err: unknown) {
      setErrMsg((err as ApiError)?.err_msg || '登录失败，请稍后重试');
    } finally {
      setLoading(false);
    }
  };
  return (
    <div className={styles.page}>
      {/* <img src={logo} alt="logo" className={styles.logo} /> */}
      <div className={styles.title}>GEO管理平台</div>
      <div className={styles.box}>
        <Form
          form={form}
          autoComplete="off"
          className={styles.form_box}
          onFinish={onFinish}
          onValuesChange={() => {
            setErrMsg('');
          }}
        >
          <Form.Item
            name="email"
            rules={[
              { required: true, message: '*请输入正确的邮箱地址！' },
              {
                type: 'email',
                message: '*请输入正确的邮箱地址！',
              },
            ]}
            style={{ marginBottom: '28px' }}
          >
            <Input className={styles.form_input} prefix={<img src={EmailIcon} />} placeholder="请输入邮箱账号" />
          </Form.Item>
          <Form.Item name="password" rules={[{ required: true, message: '请输入密码！' }]}>
            <Input.Password
              className={styles.form_input}
              prefix={<img src={PasswordIcon} />}
              placeholder="请输入密码"
              iconRender={(visible) => <img src={visible ? passwordShownIcon : passwordHiddenIcon} />}
            />
          </Form.Item>
          <span className={styles.error_msg}>{errMsg}</span>
          <Form.Item>
            <Button className={styles.form_submit} block type="primary" htmlType="submit" loading={loading}>
              {!loading && '登录'}
            </Button>
          </Form.Item>
        </Form>
      </div>
    </div>
  );
};
export default Login;
